import React, { useState } from 'react'
import styles from './im.scss'
import headset from '@/common/images/svgs/headset.svg'
import douyinIcon from '@/common/images/icon/video.png'
import videoCode from '@/common/images/pageHome/bt-1.png'
import wechatIcon from '@/common/images/icon/weixin2.png'
import wechatCode from '@/common/images/pageHome/bt-2.jpg'
import wecomCode from '@/common/images/pageHome/qw.jpg'
import { openIM } from '@/utils/im'

const imItems = [
  { key: 'online', label: '在线咨询', icon: headset },
  { key: 'wecom', label: '企微咨询', icon: wechatIcon },
  { key: 'video', label: '视频号', icon: douyinIcon }
]

export default function Im() {
  const [visibleCode, setVisibleCode] = useState(null)

  const handleItemClick = (key) => {
    if (key === 'online') {
      setVisibleCode(null)
      openIM()
      return
    }
  }

  const showCode = (key) => setVisibleCode(key)
  const hideCode = (key) => setVisibleCode((visible) => (visible === key ? null : visible))

  const renderWecomCode = () => (
    <div className={`${styles['code-popup']} ${styles['wecom-code']}`} role='dialog' aria-label='企微咨询二维码'>
      <figure>
        <img src={wechatCode} alt='微信二维码' />
        <figcaption>微信</figcaption>
      </figure>
      <figure>
        <img src={wecomCode} alt='企业微信二维码' />
        <figcaption>企业微信</figcaption>
      </figure>
    </div>
  )

  return (
    <aside className={styles['cust-im']} aria-label='侧边咨询'>
      {imItems.map((item) => {
        const itemButton = (
          <button
            type='button'
            className={styles['im-item']}
            onClick={() => handleItemClick(item.key)}
            onFocus={item.key === 'online' ? undefined : () => showCode(item.key)}
            onBlur={item.key === 'online' ? undefined : () => hideCode(item.key)}
            aria-expanded={item.key === 'online' ? undefined : visibleCode === item.key}
          >
            <span className={styles['im-icon-content']}>
              <img src={item.icon} alt='' className={styles['img-icon']} />
            </span>
            <span className={styles['im-text']}>{item.label}</span>
          </button>
        )

        if (item.key === 'online') {
          return <React.Fragment key={item.key}>{itemButton}</React.Fragment>
        }

        if (item.key === 'video') {
          return (
            <div
              className={styles['video-item']}
              key={item.key}
              onMouseEnter={() => showCode('video')}
              onMouseLeave={() => hideCode('video')}
            >
              {itemButton}
              {visibleCode === 'video' && (
                <div className={styles['video-code']} role='dialog' aria-label='视频号二维码'>
                  <img src={videoCode} alt='视频号二维码' />
                </div>
              )}
            </div>
          )
        }

        return (
          <div
            className={styles['wecom-item']}
            key={item.key}
            onMouseEnter={() => showCode('wecom')}
            onMouseLeave={() => hideCode('wecom')}
          >
            {itemButton}
            {visibleCode === 'wecom' && renderWecomCode()}
          </div>
        )
      })}

    </aside>
  )
}
